import React from 'react'
import { bool, func } from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import Tooltip from 'components/Tooltip'

require('./DesignModeSelector.scss')

const DesignModeSelector = ({ magicEraserMode, updateMagicEraserMode }) => {
    const { t } = useTranslation()

    return (
        <div className="DesignModeSelector">
            <div className={classNames('modeSelector', { editing: magicEraserMode })}>
                <Tooltip id="magicEraserDesignBtn" />
                <button
                    onClick={() => updateMagicEraserMode(false)}
                    data-testid="design-mode-selector"
                    data-tip={t('tooltip.add furniture to room')}
                    data-for="magicEraserDesignBtn"
                >
                    {t('design.design room')}
                </button>

                <Tooltip id="magicEraserEditBtn" />
                <button
                    onClick={() => updateMagicEraserMode(true)}
                    data-testid="edit-mode-selector"
                    data-tip={t('tooltip.hide unwanted items')}
                    data-for="magicEraserEditBtn"
                >
                    {t('design.edit image')}
                </button>
            </div>
        </div>
    )
}

DesignModeSelector.propTypes = {
    magicEraserMode: bool.isRequired,
    updateMagicEraserMode: func.isRequired,
}

export default DesignModeSelector
